// extracted by mini-css-extract-plugin
export default {"quoteExtendBtn":"quoteExtendBtn_quoteExtendBtn__ix0b7"};